import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 3,
    boxShadow: theme.boxShadow.base,
    backgroundColor: theme.colors.white,
    width: '100%',
    borderRadius: theme.borderRadius.large,
    padding: theme.marginBase * 10,
    [theme.media.tablet]: {
      padding: [[theme.marginBase * 8, theme.marginBase * 4]],
    },
    [theme.media.mobile]: {
      padding: 0,
      boxShadow: 'none',
      maxWidth: '100%',
    },
  },
  title: {
    ...theme.fonts.h3,
    margin: 0,
    marginBottom: theme.marginBase,
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const PublicBackgroundBlock = ({ children, className }: Props) => {
  const classes = useStyles();

  return (
    <div className={classnames(classes.section, className)}>{children}</div>
  );
};
